import React, { useEffect, useState } from 'react'
import { Header, Modal, Button, Form, Grid, Checkbox, Table, Label } from 'semantic-ui-react'
import env from '../../../env'
import './AdminFulfillment.css'
import MickeyTable from '../../../components/MickeyTable/MickeyTable'
import PageHeader from '../../../components/PageHeader/PageHeader'
import AdminOrderFulfillmentSelectedRow from '../AdminOrder/AdminOrderFulfillmentSelectedRow'
import AdminFulfillmentTruckingRow from './AdminFulfillmentTruckingRow'
import LoadBoardBidsMap from './LoadBoardBidsMap'
import { useSelector } from 'react-redux'
import MickeyDropdown from '../../../components/MickeyDropdown/MickeyDropdown'
import useAxios from '../../../lib/auth/useAxios'
import { toast } from 'react-toastify'
import { Truck } from 'phosphor-react'

function AdminFulfillmentTrucking(props) {
  const axios = useAxios()
  const [reload, setReload] = useState(false)
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const [selectedCargoUnitInstance, setSelectedCargoUnitInstance] =
    useState(null)
  const [selectedTab, setSelectedTab] = useState('Unbooked')
  const [cargoUnitInstances, setCargoUnitInstances] = useState(null)
  const [selectedCargos, setSelectedCargos] = useState([])
  const [togglingLoadBoard, setTogglingLoadBoard] = useState(false)
  const [showOnlyLive, setShowOnlyLive] = useState(false)
  const [bidsViewMode, setBidsViewMode] = useState('table') // 'table' or 'map'
  const [allBids, setAllBids] = useState([])
  const [loadingBids, setLoadingBids] = useState(false)

  // Add Fulfillment Modal State
  const [addFulfillmentModal, setAddFulfillmentModal] = useState(false)
  const [addFulfillmentLoading, setAddFulfillmentLoading] = useState(false)
  const [newFulfillment, setNewFulfillment] = useState({
    order_id: null,
    cargo_unit_id: null,
    pickup_location_id: null,
    delivery_location_id: null,
    trucking_company_id: null,
    trucking_user_id: null,
    shipper_load_id: '',
    estimated_ship_date: null,
  })

  let headerRow = [
    'Load ID',
    'Live',
    'Fulfillment Companies',
    'Order',
    'Supplier',
    'Buyer',
    'Ship From',
    'Ship To',
    'Pickup Date',
    'Status',
  ]
  const headerSearch = [
    {
      header: 'Load ID',
      type: 'dropdown',
      options_url: 'get-fields-value/',
      options_params: {
        tenant_aware: false,
        model: 'CargoUnitInstance',
        query_dict: { shipper_load_id__isnull: false },
        filter_field_value_list: ['shipper_load_id'],
      },
      options_titleFields: ['shipper_load_id'],
      options_valueFields: ['shipper_load_id'],
      search_param: 'shipper_load_id',
    },
    {
      header: 'Fulfillment Companies',
      type: 'dropdown',
      options_url: 'get-fields-value/',
      options_params: {
        tenant_aware: false,
        model: 'CargoUnitInstance',
        query_dict: { trucking_company__isnull: false },
        filter_field_value_list: ['trucking_company__name'],
      },
      options_titleFields: ['trucking_company__name'],
      options_valueFields: ['trucking_company__name'],
      search_param: 'trucking_company',
    },
    {
      header: 'Order',
      type: 'dropdown',
      options_url: 'get-fields-value/',
      options_params: {
        tenant_aware: false,
        model: 'CargoUnitInstance',
        query_dict: { order__order_number__isnull: false },
        filter_field_value_list: ['order__order_number'],
      },
      options_titleFields: ['order__order_number'],
      options_valueFields: ['order__order_number'],
      search_param: 'order_number',
    },
    {
      header: 'Supplier',
      type: 'dropdown',
      options_url: 'get-fields-value/',
      options_params: {
        tenant_aware: false,
        model: 'Supplier',
        query_dict: {},
        filter_field_value_list: ['business__name'],
      },
      options_titleFields: ['business__name'],
      options_valueFields: ['business__name'],
      search_param: 'supplier',
    },
    {
      header: 'Pickup Date',
      type: 'date',
      search_param: 'estimated_ship_date',
    },
    {
      header: 'Buyer',
      type: 'dropdown',
      options_url: 'get-fields-value/',
      options_params: {
        tenant_aware: false,
        model: 'Buyer',
        query_dict: {},
        filter_field_value_list: ['business__name'],
      },
      options_titleFields: ['business__name'],
      options_valueFields: ['business__name'],
      search_param: 'buyer',
    },
  ]
  const headerSort = [
    {
      header: 'Load ID',
      sort_by: 'shipper_load_id',
    },
    {
      header: 'Fulfillment Companies',
      sort_by: 'trucking_company__name',
    },
    {
      header: 'Order',
      hide_sort_by: true,
    },
    {
      header: 'Supplier',
      hide_sort_by: true,
    },
    {
      header: 'Pickup Date',
      sort_by: 'estimated_ship_date',
    },
    {
      header: 'Buyer',
      hide_sort_by: true,
    },
    {
      header: 'Status',
    },
  ]

  const toggleLoadBoard = async () => {
    if (selectedCargos.length === 0) {
      toast.error('Please select at least one fulfillment')
      return
    }

    setTogglingLoadBoard(true)
    try {
      for (const cargoId of selectedCargos) {
        await axios.post(
          `/main/admin-cargo-unit-instances/${cargoId}/toggle_load_board/`
        )
      }
      toast.success('Load board status toggled successfully!')
      setSelectedCargos([])
      setReload(true)
    } catch (error) {
      toast.error('Error toggling load board status')
      console.error('Error toggling load board:', error)
    } finally {
      setTogglingLoadBoard(false)
    }
  }

  const handleAddFulfillment = async () => {
    if (!newFulfillment.order_id) {
      toast.error('Please select an order')
      return
    }
    if (!newFulfillment.shipper_load_id) {
      toast.error('Please enter a Shipper Load ID')
      return
    }

    setAddFulfillmentLoading(true)
    try {
      const res = await axios.post('/main/admin-cargo-unit-instances/', {
        order: newFulfillment.order_id,
        cargo_unit: newFulfillment.cargo_unit_id,
        pickup_location: newFulfillment.pickup_location_id,
        delivery_location: newFulfillment.delivery_location_id,
        trucking_company: newFulfillment.trucking_company_id,
        trucking_user: newFulfillment.trucking_user_id,
        shipper_load_id: newFulfillment.shipper_load_id,
        estimated_ship_date: newFulfillment.estimated_ship_date,
      })

      if (res.data?.id || res.status < 300) {
        toast.success('Fulfillment created successfully!')
        setAddFulfillmentModal(false)
        setNewFulfillment({
          order_id: null,
          cargo_unit_id: null,
          pickup_location_id: null,
          delivery_location_id: null,
          trucking_company_id: null,
          trucking_user_id: null,
          shipper_load_id: '',
          estimated_ship_date: null,
        })
        setReload(true)
      } else {
        toast.error(res.data?.error || 'Error creating fulfillment')
      }
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Error creating fulfillment')
    } finally {
      setAddFulfillmentLoading(false)
    }
  }

  const fetchAllBids = async () => {
    setLoadingBids(true)
    try {
      const res = await axios.get('/main/load-board-bids/', {
        params: {
          page_size: 1000, // Get all bids
        },
      })
      setAllBids(res.data?.results || [])
    } catch (error) {
      console.error('Error fetching bids:', error)
      toast.error('Error loading bids')
    } finally {
      setLoadingBids(false)
    }
  }

  // Fetch bids when Bids tab is selected
  useEffect(() => {
    if (selectedTab === 'Bids') {
      fetchAllBids()
    }
  }, [selectedTab])

  // Auto-refresh bids every 30 seconds when on Bids tab
  useEffect(() => {
    let intervalId
    if (selectedTab === 'Bids') {
      intervalId = setInterval(() => {
        fetchAllBids()
      }, 30000)
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [selectedTab])

  return (
    <div style={{ padding: 0, marginTop: '0px' }}>
      {!props.hideHeader && (
        <PageHeader
          icon={'truck'}
          header={'Fulfillment'}
          buttons={[
            {
              color: 'primary',
              content: 'Toggle Load Board',
              onClick: toggleLoadBoard,
              loading: togglingLoadBoard,
              disabled: togglingLoadBoard || selectedCargos.length === 0,
              icon: <Truck size={16} />,
              style: {
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              },
            },
            {
              color: 'primary',
              content: 'Add Fulfillment',
              onClick: () => {
                setAddFulfillmentModal(true)
              },
              style: {
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              },
            },
          ]}
        />
      )}
      <div style={{ marginLeft: '10px', marginBottom: '15px' }}>
        <Checkbox
          label="Show Only Live Loads"
          checked={showOnlyLive}
          onChange={(e, data) => {
            setShowOnlyLive(data.checked)
            setReload(true)
          }}
        />
      </div>
      <div
        className="exchange-table-heading"
        style={{ marginLeft: '10px', marginBottom: '15px' }}
      >
        <div className="commodities-wrapper">
          <Header
            as={'h2'}
            className={
              selectedTab === 'Unbooked'
                ? 'commodity-header selected'
                : 'commodity-header'
            }
            color={selectedTab === 'Unbooked' ? 'primary' : 'black'}
            onClick={() => setSelectedTab('Unbooked')}
            style={{
              margin: '0 1rem 0rem 0',
              '--primaryColor': tenant?.deployment_primary_color,
            }}
          >
            Unbooked
          </Header>
          <Header
            as={'h2'}
            className={
              selectedTab === 'Booked'
                ? 'commodity-header selected'
                : 'commodity-header'
            }
            color={selectedTab === 'Booked' ? 'primary' : 'black'}
            onClick={() => setSelectedTab('Booked')}
            style={{
              margin: '0 1rem 0rem 0',
              '--primaryColor': tenant?.deployment_primary_color,
            }}
          >
            Booked
          </Header>
          <Header
            as={'h2'}
            className={
              selectedTab === 'Bids'
                ? 'commodity-header selected'
                : 'commodity-header'
            }
            color={selectedTab === 'Bids' ? 'primary' : 'black'}
            onClick={() => setSelectedTab('Bids')}
            style={{
              margin: '0 1rem 0rem 0',
              '--primaryColor': tenant?.deployment_primary_color,
            }}
          >
            Bids
          </Header>
        </div>
      </div>

      {/* Conditional rendering based on selected tab */}
      {selectedTab !== 'Bids' && (
        <MickeyTable
        headerRow={headerRow}
        headerSearch={headerSearch}
        headerSort={headerSort}
        url={'/main/admin-cargo-unit-instances/'}
        urlParams={{
          trucking_booked: selectedTab === 'Booked' ? 'true' : 'false',
          salesperson_id: props?.salespersonId,
          light_serializer: true,
          exclude_container_items: true,
          // Filter logic:
          // - If showOnlyLive is checked, only show live loads
          // - If on Booked tab (and showOnlyLive is false), exclude live loads
          ...(showOnlyLive
            ? { live_on_load_board: 'true' }
            : selectedTab === 'Booked'
              ? { live_on_load_board: 'false' }
              : {}
          ),
        }}
        reload={reload}
        setReload={setReload}
        setParentRow={setCargoUnitInstances}
        basicSegment
        renderBodyRow={(data, index) => {
          return (
            <>
              <AdminFulfillmentTruckingRow
                selectedCargoUnitInstance={selectedCargoUnitInstance}
                setSelectedCargoUnitInstance={setSelectedCargoUnitInstance}
                cargoUnitInstance={cargoUnitInstances[index]}
                setCargoUnitInstance={(cui) => {
                  let cuisCopy = [...cargoUnitInstances]
                  cuisCopy[index] = cui
                  setCargoUnitInstances(cuisCopy)
                }}
                selectedCargos={selectedCargos}
                setSelectedCargos={setSelectedCargos}
              />
              {selectedCargoUnitInstance?.id === data?.id && (
                <AdminOrderFulfillmentSelectedRow
                  selectedCargoUnitInstance={selectedCargoUnitInstance}
                  setSelectedCargoUnitInstance={setSelectedCargoUnitInstance}
                  setCargoUnitInstance={(cui) => {
                    let cuisCopy = [...cargoUnitInstances]
                    cuisCopy[index] = cui
                    setCargoUnitInstances(cuisCopy)
                  }}
                  cargoUnitInstance={cargoUnitInstances[index]}
                  setReload={setReload}
                />
              )}
            </>
          )
        }}
        emptyIcon={'truck'}
        emptyMessage={'Fulfillment will populate here'}
      />
      )}

      {/* Bids Tab Content */}
      {selectedTab === 'Bids' && (
        <div style={{ padding: '20px' }}>
          <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
            <Button
              color={bidsViewMode === 'table' ? 'primary' : undefined}
              onClick={() => setBidsViewMode('table')}
              style={{
                '--primaryColor': tenant?.deployment_primary_color,
              }}
            >
              Table View
            </Button>
            <Button
              color={bidsViewMode === 'map' ? 'primary' : undefined}
              onClick={() => setBidsViewMode('map')}
              style={{
                '--primaryColor': tenant?.deployment_primary_color,
              }}
            >
              Map View
            </Button>
          </div>

          {bidsViewMode === 'table' && (
            <MickeyTable
              headerRow={[
                'Load ID',
                'Trucking Company',
                'Bid Price',
                'Status',
                'From',
                'To',
                'Submitted By',
                'Date',
              ]}
              data={allBids}
              renderBodyRow={(bid, index) => {
                return (
                  <Table.Row
                    positive={bid?.status === 'accepted'}
                    negative={bid?.status === 'rejected'}
                  >
                    <Table.Cell>
                      {bid?.cargo_unit_instance?.shipper_load_id || 'N/A'}
                    </Table.Cell>
                    <Table.Cell>
                      {bid?.trucking_company?.name || 'N/A'}
                    </Table.Cell>
                    <Table.Cell>
                      ${parseFloat(bid?.bid_price || 0).toFixed(2)}
                    </Table.Cell>
                    <Table.Cell>
                      <Label
                        color={
                          bid?.status === 'accepted'
                            ? 'green'
                            : bid?.status === 'rejected'
                            ? 'red'
                            : 'grey'
                        }
                        content={
                          bid?.status?.charAt(0).toUpperCase() +
                          bid?.status?.slice(1)
                        }
                      />
                    </Table.Cell>
                    <Table.Cell>
                      {bid?.cargo_unit_instance?.pickup_location?.city || 'N/A'},{' '}
                      {bid?.cargo_unit_instance?.pickup_location?.state || 'N/A'}
                    </Table.Cell>
                    <Table.Cell>
                      {bid?.cargo_unit_instance?.delivery_location?.city || 'N/A'},{' '}
                      {bid?.cargo_unit_instance?.delivery_location?.state || 'N/A'}
                    </Table.Cell>
                    <Table.Cell>
                      {bid?.user?.first_name} {bid?.user?.last_name}
                    </Table.Cell>
                    <Table.Cell>
                      {new Date(bid?.created_at).toLocaleDateString()}
                    </Table.Cell>
                  </Table.Row>
                )
              }}
              emptyIconHtml={<Truck size={40} />}
              emptyMessage={'No bids yet'}
            />
          )}

          {bidsViewMode === 'map' && (
            <LoadBoardBidsMap bids={allBids} loading={loadingBids} />
          )}
        </div>
      )}

      {/* Add Fulfillment Modal */}
      <Modal
        size="large"
        onClose={() => {
          setAddFulfillmentModal(false)
          setNewFulfillment({
            order_id: null,
            cargo_unit_id: null,
            pickup_location_id: null,
            delivery_location_id: null,
            trucking_company_id: null,
            trucking_user_id: null,
            shipper_load_id: '',
            estimated_ship_date: null,
          })
        }}
        open={addFulfillmentModal}
      >
        <Modal.Header>Add Fulfillment</Modal.Header>
        <Modal.Content>
          <Form>
            <Grid>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Form.Field required>
                    <label>Order</label>
                    <MickeyDropdown
                      url="/main/admin-orders/"
                      name="order"
                      value={newFulfillment.order_id}
                      autoComplete="new-password"
                      tenantAware={false}
                      placeholder="Select Order"
                      titleFields={['order_number']}
                      descriptionFields={['buyer.business.name']}
                      onChange={(e, d) => {
                        setNewFulfillment({ ...newFulfillment, order_id: d.value })
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Form.Field>
                    <label>Cargo Type</label>
                    <MickeyDropdown
                      url="/main/cargo-units/"
                      name="cargo_unit"
                      value={newFulfillment.cargo_unit_id}
                      autoComplete="new-password"
                      tenantAware={false}
                      placeholder="Select Cargo Type"
                      titleFields={['singular_name']}
                      descriptionFields={[]}
                      onChange={(e, d) => {
                        setNewFulfillment({
                          ...newFulfillment,
                          cargo_unit_id: d.value,
                        })
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Form.Field>
                    <label>Fulfillment Company</label>
                    <MickeyDropdown
                      url="/main/list-trucking-companies/"
                      name="trucking_company"
                      value={newFulfillment.trucking_company_id}
                      autoComplete="new-password"
                      tenantAware={false}
                      placeholder="Select Fulfillment Company"
                      titleFields={['name']}
                      descriptionFields={['type']}
                      onChange={(e, d) => {
                        setNewFulfillment({
                          ...newFulfillment,
                          trucking_company_id: d.value,
                        })
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Form.Field>
                    <label>Fulfillment User</label>
                    <MickeyDropdown
                      url="/main/custom-users/"
                      name="trucking_user"
                      value={newFulfillment.trucking_user_id}
                      autoComplete="new-password"
                      tenantAware={false}
                      placeholder="Select Fulfillment User"
                      titleFields={['first_name', 'last_name']}
                      descriptionFields={[]}
                      params={{
                        trucking_company_id: newFulfillment.trucking_company_id,
                      }}
                      disabled={!newFulfillment.trucking_company_id}
                      onChange={(e, d) => {
                        setNewFulfillment({
                          ...newFulfillment,
                          trucking_user_id: d.value,
                        })
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Form.Field>
                    <label>Pickup Location</label>
                    <MickeyDropdown
                      url="/main/admin-locations/"
                      name="pickup_location"
                      value={newFulfillment.pickup_location_id}
                      autoComplete="new-password"
                      tenantAware={false}
                      placeholder="Select Pickup Location"
                      titleFields={['name', 'address_1']}
                      descriptionFields={['city', 'state', 'zip_code']}
                      params={{
                        is_pickup: true,
                      }}
                      onChange={(e, d) => {
                        setNewFulfillment({
                          ...newFulfillment,
                          pickup_location_id: d.value,
                        })
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Form.Field>
                    <label>Delivery Location</label>
                    <MickeyDropdown
                      url="/main/admin-locations/"
                      name="delivery_location"
                      value={newFulfillment.delivery_location_id}
                      autoComplete="new-password"
                      tenantAware={false}
                      placeholder="Select Delivery Location"
                      titleFields={['name', 'address_1']}
                      descriptionFields={['city', 'state', 'zip_code']}
                      params={{
                        is_delivery: true,
                      }}
                      onChange={(e, d) => {
                        setNewFulfillment({
                          ...newFulfillment,
                          delivery_location_id: d.value,
                        })
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Form.Field required>
                    <label>Shipper Load ID</label>
                    <Form.Input
                      placeholder="Shipper Load ID"
                      value={newFulfillment.shipper_load_id}
                      onChange={(e, d) => {
                        setNewFulfillment({
                          ...newFulfillment,
                          shipper_load_id: d.value,
                        })
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Form.Field>
                    <label>Estimated Ship Date</label>
                    <Form.Input
                      type="date"
                      value={newFulfillment.estimated_ship_date || ''}
                      onChange={(e, d) => {
                        setNewFulfillment({
                          ...newFulfillment,
                          estimated_ship_date: d.value,
                        })
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              setAddFulfillmentModal(false)
              setNewFulfillment({
                order_id: null,
                cargo_unit_id: null,
                pickup_location_id: null,
                delivery_location_id: null,
                trucking_company_id: null,
                trucking_user_id: null,
                shipper_load_id: '',
                estimated_ship_date: null,
              })
            }}
            color="black"
            style={{
              padding: '.75rem',
              borderRadius: '500px',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddFulfillment}
            loading={addFulfillmentLoading}
            disabled={addFulfillmentLoading}
            color="primary"
            style={{
              '--primaryColor': tenant?.deployment_primary_color,
              '--secondaryColor': tenant?.deployment_secondary_color,
              '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
            }}
          >
            Add Fulfillment
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

export default AdminFulfillmentTrucking
